import { mapState, mapActions } from 'vuex';

const GameChatMixin = {
  data() {
    return {
      MAX_MESSAGES_WITHOUT_REPLY: 2,
      messagesCounter: 0,
      showOptions: false,
      answerTypes: { EMOJI: 'EMOJI', TEXT: 'TEXT' },
      states: {
        INITIAL: { value: 'INITIAL' },
        RECEIVED: { value: 'RECEIVED', text: ['home_game_chat_received_text'] },
        ERROR: { value: 'ERROR', text: ['home_game_chat_error_text1', 'home_game_chat_error_text2'] },
      },
      currentState: 'INITIAL',
      currentAnswer: {
        type: '',
        content: '',
        sender: '',
      },
      chatSubscription: null,
    };
  },
  methods: {
    ...mapActions('game', [
      'sendConversationMessage',
    ]),
    clearAnswer() {
      this.currentAnswer = {
        type: '',
        content: '',
        sender: '',
      };
    },
    resetChat() {
      this.resetState();
      this.resetCounter();
      this.clearAnswer();
    },
    resetCounter() {
      this.messagesCounter = 0;
    },
    setState(state) {
      this.currentState = state;
    },
    resetState() {
      this.currentState = this.states.INITIAL.value;
    },
    sendMessage() {
      this.currentState = this.states.INITIAL.value;
      this.initChat();
    },
    checkIfError() {
      return this.messagesCounter === this.MAX_MESSAGES_WITHOUT_REPLY;
    },
    initChat() {
      if (this.checkIfError()) {
        this.setState(this.states.ERROR.value);
      } else {
        this.showOptions = true;
      }
    },
    selectAnswer(answer) {
      if (this.currentState === this.states.INITIAL.value) {
        this.currentAnswer.type = answer.type;
        this.currentAnswer.content = answer.content;
        const payload = {
          gameId: this.gameID,
          type: this.currentAnswer.type,
          message: this.currentAnswer.content,
          sender: this.userDetails.username,
          receiver: this.getOpponentUsername(),
          pvp: this.isPvp(),
        };
        this.sendConversationMessage(payload).then(() => {
          this.messagesCounter = this.messagesCounter + 1;
          this.showOptions = false;
        });
      }
    },
    connectToChat() {
      this.chatSubscription = this.stompClient.subscribe(`/topic/conversation/${this.gameID}`, (response) => {
        // eslint-disable-next-line
        console.log('[Game] Inside conversation topic response');
        const responseBody = this.parseServerResponse(response.body);
        if (responseBody === null) {
          // eslint-disable-next-line
          console.log('Unable to parse conversation response');
          return;
        }
        const responseData = responseBody.data;
        // eslint-disable-next-line
        console.log('conversation responseData:', responseData);
        const content = responseData.message;
        const type = responseData.type;
        const sender = responseData.sender;
        if (sender !== this.userDetails.username) {
          this.currentAnswer.type = type;
          this.currentAnswer.content = content;
          this.currentAnswer.sender = this.getOpponentUsername();
          this.setState(this.states.RECEIVED.value);
          this.resetCounter();
        }
      });
    },
    disconnectFromChat() {
      if (this.chatSubscription) {
        this.chatSubscription.unsubscribe();
      }
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
  },
};

export default GameChatMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/chat/gameChat.js